/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-alert */
import { AxiosError } from 'axios';
import { get } from 'lodash';
import Toast from 'react-native-toast-message';

export const errorHandler = ({ error }: { error: any }) => {
  if (window?.nham24?.request) {
    window?.nham24?.request('consolelog', error);
  }
  console.log({ error });
  console.log('instanceof AxiosError', error instanceof AxiosError);
  if (error instanceof AxiosError) {
    if (error.response?.status === 422 || error.response?.status === 500) {
      // console.log({ status: error.response.status, response: error.response.data });

      // Alert.alert('Error', castingError(error), button);
      Toast.show({
        type: 'error',
        text1: 'Error',
        text2: castingError(error),
        visibilityTime: 10000,
      });
      return error;
    }
    // Alert.alert('Error', error.message, button);
    Toast.show({
      type: 'error',
      text1: 'Error',
      text2: error.message,
      visibilityTime: 10000,
    });
  }
  return error;
};

export const castingError = (error: any) => {
  const errorMessage = get(error, 'response.data.errors.message');
  const message = get(error, 'response.data.message');
  if (errorMessage) return errorMessage;
  return message;
};
